import React from 'react';
import { Box, Container } from '@mui/material';

export const SimpleLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <main>
    <Container>
      <Box
        sx={{
          p: 5,
        }}>
        {children}
      </Box>
    </Container>
  </main>
);
